import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import { ApiErrors } from 'app/shared/api/ApiErrors';
import type { CommissionGroupOfferRequest } from './serializeCommissionOffer';

async function saveCommissionGroupsRequest(
  divisionId: number,
  payload: CommissionGroupOfferRequest,
  failureMessage: string,
  pathKey: 'commission_group_create' | 'commission_group_update'
): Promise<{ ok: boolean; message?: string }> {
  const localApi = await getLocalApi();
  const url = (apiConfig as Record<string, string>)[pathKey]?.replace('{divisionId}', String(divisionId));
  if (!url) {
    return { ok: false, message: 'Commission API configuration is missing' };
  }
  const response = await localApi.call(url, 'PUT', JSON.stringify(payload));
  if (!response) {
    return { ok: false, message: 'No response from server' };
  }
  const text = await response.text().catch(() => '');
  let data: any = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  const errors = ApiErrors.extractAllErrors(data, response, failureMessage);
  const isFailed = data?.isFailed === true || data?.isSuccess === false;
  if (!response.ok || (isFailed && errors.length > 0)) {
    return { ok: false, message: ApiErrors.formatErrors(errors) };
  }
  return { ok: true };
}

export async function createCommissionGroups(
  divisionId: number,
  payload: CommissionGroupOfferRequest
): Promise<{ ok: boolean; message?: string }> {
  return saveCommissionGroupsRequest(divisionId, payload, 'Failed to create commission', 'commission_group_create');
}

export async function updateCommissionGroups(
  divisionId: number,
  payload: CommissionGroupOfferRequest
): Promise<{ ok: boolean; message?: string }> {
  return saveCommissionGroupsRequest(divisionId, payload, 'Failed to update commission', 'commission_group_update');
}